module.exports = function getResource(label, vars = []) {
    let resources = {
        sephoraStore: `Sephora ${vars[0]}`,
        pickupInfo: 'Pickup Info',
        callStore: 'Call Store',
        happeningAt: 'Happening at Sephora',
        seeWhatsGoingOn: 'Free services, brand launches, classes & more—see what’s going on at your store today.',
        seeWhatsHappening: 'See what’s happening at this store',
        getDirections: 'Get Directions',
        away: 'away',
        howToFindUs: 'How to find us?'
    };

    return resources[label];
};
